import React, { useEffect, useState } from "react";
import { api, formatEUR } from "@/lib/api";
import { PageHeader, MetricCard } from "@/components/ui-kit";
import { Ban, KeyRound, Briefcase, AlertTriangle, Phone, Scale, FileText, Clock, Wallet, TrendingUp, PiggyBank } from "lucide-react";

export default function DashboardAdmin() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/dashboard/admin").then((r) => setData(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="p-8 text-slate-500">Chargement…</div>;
  if (!data) return null;

  return (
    <div className="p-8" data-testid="dashboard-admin">
      <PageHeader title="Tableau de bord Admin / BackOffice" subtitle="Suivi post-signature" />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <MetricCard label="Dénonciations à traiter" value={data.denonciations_a_traiter} icon={Ban} tone="warning" testid="metric-denonciations" to="/denonciations" />
        <MetricCard label="Options en attente" value={data.options_en_attente} icon={KeyRound} tone="warning" testid="metric-options-attente" to="/options" />
        <MetricCard label="Ventes signées à suivre" value={data.ventes_signees_a_suivre} icon={Briefcase} tone="primary" testid="metric-ventes-suivre" to="/dossiers" />
        <MetricCard label="Financements en retard" value={data.financement_en_retard} icon={AlertTriangle} tone="danger" testid="metric-financement-retard" to="/financements" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <MetricCard label="Clients à relancer" value={data.clients_a_relancer} icon={Phone} tone="warning" testid="metric-clients-relancer" to="/dossiers" />
        <MetricCard label="Passages notaire à venir" value={data.notaire_a_venir} icon={Scale} testid="metric-notaire" to="/notaire" />
        <MetricCard label="Factures à envoyer" value={data.factures_a_envoyer} icon={FileText} tone="warning" testid="metric-factures-envoyer" to="/factures" />
        <MetricCard label="Factures en attente paiement" value={data.factures_en_attente} icon={Clock} tone="primary" testid="metric-factures-attente" to="/factures" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <MetricCard label="Recouvrement à effectuer" value={data.recouvrement} icon={Wallet} tone="danger" testid="metric-recouvrement" to="/recouvrement" />
        <MetricCard label="Commissions encaissées" value={formatEUR(data.ca_encaisse)} sublabel="Total factures payées" icon={PiggyBank} tone="success" testid="metric-ca-encaisse" to="/factures" />
        <MetricCard label="Commissions en attente" value={formatEUR(data.ca_en_attente)} sublabel="Ventes signées non encaissées" icon={TrendingUp} tone="gold" testid="metric-ca-attente" to="/dossiers" />
      </div>
    </div>
  );
}
